import {InjectedIntl} from "react-intl"

import authentication from "@irati/auth"

import {ShareOptionValues} from "../enums"

export const EVERYONE = "everyone"
export const PRIVATE = "private"
export const PROPERTY = "share"
export const SPECIFIC_TEAMS = "specific_teams"
export const TEAMS = "teams"

export const EVERYONE_OPTION = (intl: InjectedIntl) => ({
  label: intl.formatMessage({id: "reward.fields.share.option.everyone"}, {tenantName: authentication.userTenant().public_name}),
  value: ShareOptionValues.EVERYONE
})

export const PRIVATE_OPTION = (intl: InjectedIntl) => ({
  label: intl.formatMessage({id: "reward.fields.share.option.private"}),
  value: ShareOptionValues.PRIVATE
})

export const SPECIFIC_TEAMS_OPTION = (intl: InjectedIntl) => ({
  label: intl.formatMessage({id: "reward.fields.share.option.specific"}),
  value: SPECIFIC_TEAMS
})

export const TEAMS_OPTION = (intl: InjectedIntl) => ({
  label: intl.formatMessage({id: "reward.fields.share.option.teams"}),
  value: ShareOptionValues.TEAMS
})

export const DEFAULT_OPTIONS = (intl: InjectedIntl) => [EVERYONE_OPTION(intl), TEAMS_OPTION(intl), PRIVATE_OPTION(intl)]

export default (intl: InjectedIntl, canShareWithEveryone = false, canBeSharedWithTeams = false) => {
  const options = []

  if (canShareWithEveryone) {
    options.push(EVERYONE_OPTION(intl))
  }

  if (canBeSharedWithTeams) {
    options.push(TEAMS_OPTION(intl))
  }

  options.push(PRIVATE_OPTION(intl))

  return options
}
